import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Skeleton} from '@chakra-ui/react'

/**
 * Placeholder shown while a carousel's dynamic product tiles (Vicky/Einstein,
 * Early Access, etc.) are still being fetched. Mirrors the carousel layout —
 * a row of product-card placeholders (image + two text lines) — so the user
 * perceives that products are loading, instead of a bare spinner.
 *
 * `itemWidth` should match the real slide width (from `buildSlideWidth`) so the
 * skeleton shows the same number of tiles per row as the resolved layout.
 */
const CarouselGridSkeleton = ({count = 2, itemWidth, gap = 3}) => (
    <Flex
        gap={gap}
        overflow="hidden"
        py={6}
        px={{base: 4, lg: 0}}
        data-testid="gdi-carousel-grid-skeleton"
    >
        {Array.from({length: count}).map((_, i) => (
            <Box key={i} flex="0 0 auto" width={itemWidth || '48%'}>
                <Box position="relative" width="100%" pb="125%">
                    <Skeleton position="absolute" top={0} left={0} width="100%" height="100%" borderRadius="md" />
                </Box>
                <Skeleton height={4} width="80%" mt={3} />
                <Skeleton height={4} width="50%" mt={2} />
            </Box>
        ))}
    </Flex>
)

CarouselGridSkeleton.propTypes = {
    count: PropTypes.number,
    itemWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
}

export default CarouselGridSkeleton
